module.exports = __webpack_public_path__ + "img/Wp_2059.77e00aa8.png";